import bindAll from 'lodash.bindall';
import PropTypes from 'prop-types';
import React from 'react';
import {connect} from 'react-redux';
import {injectIntl, intlShape, defineMessages} from 'react-intl';
import VM from 'scratch-vm';

import spriteLibraryContent from '../lib/libraries/sprites.json';
import randomizeSpritePosition from '../lib/randomize-sprite-position';
import spriteTags from '../lib/libraries/sprite-tags';
import {activateTab, BLOCKS_TAB_INDEX} from '../reducers/editor-tab';

import LibraryComponent from '../components/library/library.jsx';

const messages = defineMessages({
    libraryTitle: {
        defaultMessage: 'Choose a Sprite',
        description: 'Heading for the sprite library',
        id: 'gui.spriteLibrary.chooseASprite'
    }
});

class SpriteLibrary extends React.PureComponent {
    constructor (props) {
        super(props);
        bindAll(this, [
            'handleItemSelect'
        ]);
    }
    // handleItemSelect (item) {
    //     console.log('Đã nhấn chọn nhân vật:', item);

    //     if (!this.props.vm) {
    //         console.error('Không có this.props.vm');
    //         return;
    //     }
    
    //     // const newSprite = JSON.parse(JSON.stringify(item));

    //     // randomizeSpritePosition(newSprite);

    //     randomizeSpritePosition(item);



    //     const oldTargetCount = this.props.vm.runtime.targets.length;

    //     console.log('Số target trước khi thêm:', oldTargetCount);

    //     // console.log('Chuẩn bị gọi vm.addSprite:', newSprite.name);
    //     console.log('Chuẩn bị gọi vm.addSprite:', item.name);
    //     console.log('Sprite JSON:', JSON.stringify(item));

    //     this.props.vm.addSprite(JSON.stringify(item))
    //         .then(() => {
    //             console.log('vm.addSprite resolve:', item.name);
    //         })
    //         .catch(error => {
    //             console.error('Lỗi khi thêm sprite:', error);
    //         });

    //     // const addSpritePromise = this.props.vm.addSprite(JSON.stringify(newSprite));
        
    //     let count = 0;

    //     const timer = setInterval(() => {
    //         count++;

    //         const newTargetCount = this.props.vm.runtime.targets.length;

    //         console.log('Kiểm tra target:', newTargetCount);

    //         if (newTargetCount > oldTargetCount) {
    //             clearInterval(timer);

    //             console.log('Đã thêm sprite vào VM:', item.name);
    //             console.log(
    //                 'Danh sách target:',
    //                 this.props.vm.runtime.targets.map(t => t.sprite && t.sprite.name)
    //             );

    //             if (this.props.onActivateBlocksTab) {
    //                 this.props.onActivateBlocksTab();
    //             }

    //             if (this.props.onRequestClose) {
    //                 this.props.onRequestClose();
    //             }
    //         }

    //         if (count >= 30) {
    //             clearInterval(timer);
    //             console.warn('Không thấy target mới sau 3 giây:', item.name);
    //         }
    //     }, 100);


    //     // const addSpritePromise = this.props.vm.addSprite(JSON.stringify(item));

    //     // setTimeout(() => {
    //     //     console.warn('vm.addSprite vẫn chưa xong sau 5 giây:', item.name);
    //     //     console.log(
    //     //         'Số target sau 5 giây:',
    //     //         this.props.vm.runtime.targets.length,
    //     //         this.props.vm.runtime.targets.map(t => t.sprite && t.sprite.name)
    //     //     );
    //     // }, 5000);

    //     // addSpritePromise
    //     //     .then(() => {
    //     //         console.log('Đã thêm sprite thành công:', newSprite.name);

    //     //         console.log(
    //     //             'Số nhân vật hiện tại:',
    //     //             this.props.vm.runtime.targets.length
    //     //         );

    //     //         if (this.props.onActivateBlocksTab) {
    //     //             this.props.onActivateBlocksTab();
    //     //         }

    //     //         if (this.props.onRequestClose) {
    //     //             this.props.onRequestClose();
    //     //         }
    //     //     })
    //     //     .catch(error => {
    //     //         console.error('Lỗi khi thêm sprite:', error);
    //     //     });

    //     // // Randomize position of library sprite
    //     // randomizeSpritePosition(item);
    //     // this.props.vm.addSprite(JSON.stringify(item)).then(() => {
    //     //     this.props.onActivateBlocksTab();
    //     // });
    // }

    // handleItemSelect (item) {
    //     console.log('Đã nhấn chọn nhân vật:', item);

    //     if (!this.props.vm) {
    //         console.error('Không có this.props.vm');
    //         return;
    //     }

    //     const newSprite = JSON.parse(JSON.stringify(item));

    //     randomizeSpritePosition(newSprite);

    //     // Tạm bỏ sound để tránh kẹt addSprite
    //     newSprite.sounds = [];

    //     const oldTargetCount = this.props.vm.runtime.targets.length;

    //     console.log('Số target trước khi thêm:', oldTargetCount);
    //     console.log('Chuẩn bị gọi vm.addSprite:', newSprite.name);
    //     console.log('Sprite JSON:', JSON.stringify(newSprite));

    //     this.props.vm.addSprite(JSON.stringify(newSprite))
    //         .then(() => {
    //             console.log('vm.addSprite resolve:', newSprite.name);
    //         })
    //         .catch(error => {
    //             console.error('Lỗi khi thêm sprite:', error);
    //         });

    //     let count = 0;

    //     const timer = setInterval(() => {
    //         count++;

    //         const newTargetCount = this.props.vm.runtime.targets.length;

    //         console.log('Kiểm tra target:', newTargetCount);

    //         if (newTargetCount > oldTargetCount) {
    //             clearInterval(timer);

    //             console.log('Đã thêm sprite vào VM:', newSprite.name);
    //             console.log(
    //                 'Danh sách target:',
    //                 this.props.vm.runtime.targets.map(t => t.sprite && t.sprite.name)
    //             );

    //             if (this.props.onActivateBlocksTab) {
    //                 this.props.onActivateBlocksTab();
    //             }

    //             if (this.props.onRequestClose) {
    //                 this.props.onRequestClose();
    //             }
    //         }

    //         if (count >= 30) {
    //             clearInterval(timer);
    //             console.warn('Không thấy target mới sau 3 giây:', newSprite.name);
    //         }
    //     }, 100);
    // }

    // handleItemSelect (item) {
    //     console.log('Đã nhấn chọn nhân vật:', item);

    //     randomizeSpritePosition(item);

    //     this.props.vm.addSprite(JSON.stringify(item))
    //         .then(() => {
    //             console.log('Đã thêm sprite thành công:', item.name);
    //             this.props.onActivateBlocksTab();

    //             if (this.props.onRequestClose) {
    //                 this.props.onRequestClose();
    //             }
    //         })
    //         .catch(error => {
    //             console.error('Lỗi khi thêm sprite:', error);
    //         });
    // }

    // handleItemSelect (item) {
    //     console.log('Đã nhấn chọn nhân vật:', item);

    //     randomizeSpritePosition(item);

    //     this.props.vm.addSprite(JSON.stringify(item))
    //         .then(() => {
    //             console.log('Đã thêm sprite thành công:', item.name);
    //             this.props.onActivateBlocksTab();

    //             if (this.props.onRequestClose) {
    //                 this.props.onRequestClose();
    //             }
    //         })
    //         .catch(error => {
    //             console.error('Lỗi khi thêm sprite:', error);
    //         });
    // }

    handleItemSelect (item) {
        console.log('Đã nhấn chọn nhân vật:', item);

        randomizeSpritePosition(item);

        const before = this.props.vm.runtime.targets.length;
        console.log('Target trước:', before);

        // const promise = this.props.vm.addSprite(JSON.stringify(item));

        // setTimeout(() => {
        //     console.warn('Sau 5 giây target:', this.props.vm.runtime.targets.length);
        //     console.log(
        //         'Danh sách target:',
        //         this.props.vm.runtime.targets.map(t => t.sprite && t.sprite.name)
        //     );
        // }, 5000);

        // promise
        //     .then(() => {
        //         console.log('Đã thêm sprite thành công:', item.name);
        //         this.props.onActivateBlocksTab();

        //         if (this.props.onRequestClose) {
        //             this.props.onRequestClose();
        //         }
        //     })
        //     .catch(error => {
        //         console.error('Lỗi khi thêm sprite:', error);
        //     });
    
        this.props.vm.addSprite(JSON.stringify(item))
            .then(() => {
                console.log('Đã thêm sprite thành công:', item.name);
                console.log(
                    'Danh sách target sau add:',
                    this.props.vm.runtime.targets.map(t => t.sprite.name)
                );

                this.props.onActivateBlocksTab();

                if (this.props.onRequestClose) {
                    this.props.onRequestClose();
                }
            })
            .catch(error => {
                console.error('Lỗi khi thêm sprite:', item.name, error);
                console.log('Item lỗi:', JSON.stringify(item, null, 2));
            });

        setTimeout(() => {
            console.warn('Sau 5 giây target:', this.props.vm.runtime.targets.length);
            console.log(
                'Danh sách target:',
                this.props.vm.runtime.targets.map(t => t.sprite.name)
            );
        }, 5000);
    }

    render () {
        const catAndUnicorn = spriteLibraryContent
        .filter(sprite =>
            sprite.name === 'Cat' || sprite.name === 'Unicorn-CUSC'
        )
        .map(sprite => {
            if (sprite.name === 'Unicorn-CUSC') {
                return {
                    ...sprite,
                    localIconURL: '/static/assets/16f4250f511e3fa25de8d61263e824ee.svg'
                };
            }

            return sprite;
        });

        return (
            <LibraryComponent
                // data={spriteLibraryContent}
                data={catAndUnicorn}
                id="spriteLibrary"
                tags={spriteTags}
                title={this.props.intl.formatMessage(messages.libraryTitle)}
                onItemSelected={this.handleItemSelect}
                onRequestClose={this.props.onRequestClose}
            />
        );
    }
}

SpriteLibrary.propTypes = {
    intl: intlShape.isRequired,
    onActivateBlocksTab: PropTypes.func.isRequired,
    onRequestClose: PropTypes.func,
    vm: PropTypes.instanceOf(VM).isRequired
};

const mapDispatchToProps = dispatch => ({
    onActivateBlocksTab: () => dispatch(activateTab(BLOCKS_TAB_INDEX))
});

export default injectIntl(connect(
    null,
    mapDispatchToProps
)(SpriteLibrary));

// export default injectIntl(SpriteLibrary);
